'use client';

import { c as _c } from "react/compiler-runtime";
import { ModalLink } from '@svenskaspelab/poolbetting/ui/Modal';
import { TipsenLink } from '@svenskaspelab/poolbetting/ui/TipsenLink';
import { cn } from '@svenskaspelab/poolbetting/ui/utils';
import { useMediaQueryAbove } from '@svenskaspelab/ui/media-query/react';
import { type ComponentProps, type PropsWithChildren, type ReactNode } from 'react';
type CouponRowWrapperProps = PropsWithChildren<{
  defaultQuery: ComponentProps<typeof TipsenLink>['href']['query'];
  queryOnSmallScreen: ComponentProps<typeof TipsenLink>['href']['query'];
  shouldScrollToTop?: boolean;
  className?: string;
}>;

/**
 * Component that wraps the coupon row and handles url query params.
 *
 * @param param0 props
 * @param param0.children the children to pass downs
 * @param param0.defaultQuery query string for large screens and also default query string
 * @param param0.queryOnSmallScreen query string for small screens
 * @param param0.shouldScrollToTop whether to scroll to top on navigation
 * @param param0.className additional class names to apply
 * @returns CouponRowWrapper component
 */
export default function CouponLinkWrapper(t0) {
  const $ = _c(12);
  const {
    defaultQuery,
    queryOnSmallScreen,
    children,
    shouldScrollToTop,
    className
  } = t0;
  const isLargeScreen = useMediaQueryAbove("md");
  const query = isLargeScreen ? defaultQuery : queryOnSmallScreen;
  const isOpeningModal = !isLargeScreen && Boolean(queryOnSmallScreen?.modal);
  const t1 = `absolute inset-0 z-1 ${className || ""}`;
  let t2;
  if ($[0] !== t1) {
    t2 = cn(t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== query) {
    t3 = {
      query
    };
    $[2] = query;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== shouldScrollToTop || $[5] !== t2 || $[6] !== t3) {
    t4 = {
      className: t2,
      href: t3,
      queriesToKeep: "ALL" as const,
      scroll: shouldScrollToTop,
      prefetch: false
    };
    $[4] = shouldScrollToTop;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const linkProps = t4;
  let t5;
  if ($[8] !== children || $[9] !== isOpeningModal || $[10] !== linkProps) {
    t5 = isOpeningModal ? <ModalLink {...linkProps}>{children}</ModalLink> : <TipsenLink {...linkProps}>{children}</TipsenLink>;
    $[8] = children;
    $[9] = isOpeningModal;
    $[10] = linkProps;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}